import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var QuaterlyTargetFourRes;
export const QuaterlyTargetFourTodo = createAsyncThunk('QuaterlyTargetFour', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'quarterly_target_list',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "iquater_id": "4",
                "iyear": '',
                "fin_year": localStorage.getItem('vfin_year').toString()

            }
        })
        return QuaterlyTargetFourRes = res.data

    } catch (error) {
        return QuaterlyTargetFourRes = error.response.data
    }
});

const QuaterlyTargetFourSlice = createSlice({
    name: 'QuaterlyTargetFour',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(QuaterlyTargetFourTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(QuaterlyTargetFourTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default QuaterlyTargetFourSlice.reducer; 